/* ============================================================================
   Doll Finder Quiz — assets/doll-finder.js
   Vanilla JS, no dependencies.

   Primary data source: Boost AI Search & Discovery Filter API
   (services.mybcapps.com/bc-sf-filter/filter) — already indexed, returns
   total_product + per-value doc_count in one call.
   Fallback: if that fails, pulls tags from /collections/{handle}/products.json
   and computes counts locally (slower, but keeps the quiz working).

   Filter ids are discovered at runtime, not hardcoded: each question below
   names its Boost filter by LABEL (e.g. "Doll Type"); the quiz looks up the
   real filterOptionId (e.g. pf_t_doll_type) from the live filter tree, and
   derives the URL param from it (pf_t_height -> ?height=...). Rename a filter
   in Boost admin and only `boostLabel` here needs updating.

   EDIT ONLY THE QUESTIONS ARRAY BELOW.
     id             unique internal key
     boostLabel     filter's label in the Boost sidebar (case-insensitive)
     fallbackParam  URL param to use if Boost is unavailable
     question       text shown to the customer
     options        { label: shown to customer, key: EXACT filter value }
   `key` must match the filter value exactly (matching is case-insensitive,
   trimmed). Several questions may share one boostLabel (style/body/features
   all under "Doll Type") — their answers combine like ticking multiple
   sidebar boxes.
   ========================================================================== */

const DOLL_FINDER_QUESTIONS = [
  {
    id: 'doll_type',
    boostLabel: 'Doll Type',
    fallbackParam: 'doll_type',
    question: 'What doll type are you drawn to?',
    options: [
      { label: 'Asian', key: 'Asian' },
      { label: 'Anime', key: 'Anime' },
      { label: 'Athletic', key: 'Athletic' },
      { label: 'Cosplay', key: 'Cosplay' },
      { label: 'Cute', key: 'Cute' },
      { label: 'Celebrity Lookalikes', key: 'Celebrity Lookalikes' },
      { label: 'Realistic', key: 'Realistic' },
      { label: 'Fantasy', key: 'Fantasy' },
      { label: 'Hentai', key: 'Hentai' },
      { label: 'Male', key: 'Male' },
      { label: 'Ebony', key: 'Ebony' },
      { label: 'Elf', key: 'Elf' },
      { label: 'Latina', key: 'Latina' },
      { label: 'Vampire', key: 'Vampire' },
      { label: 'Mature', key: 'Mature' },
      { label: 'Robotic', key: 'Robotic' },
      { label: 'Penetrable Breasts', key: 'Penetrable Breasts' },
      { label: 'Perky Breasts', key: 'Perky Breasts' },
      { label: 'Open Mouth', key: 'Open Mouth' },
      { label: 'Smiling', key: 'Smiling' },
    ],
  },
  {
    id: 'body_type',
    boostLabel: 'Body Type',
    fallbackParam: 'body_type',
    question: 'Which body type appeals to you most?',
    options: [
      { label: 'Curvy', key: 'Curvy' },
      { label: 'Skinny', key: 'Skinny' },
      { label: 'Tall', key: 'Tall' },
      { label: 'Petite', key: 'Petite' },
      { label: 'Torso', key: 'Torso' },
    ],
  },
  {
    id: 'breast_size',
    boostLabel: 'Breast Size',
    fallbackParam: 'breast_size',
    question: 'Preferred breast size?',
    options: [
      { label: 'Small', key: 'Small Breasts' },
      { label: 'Medium', key: 'Medium Breasts' },
      { label: 'Large', key: 'Large Breasts' },
      { label: 'X-Large', key: 'X-Large Breasts' },
    ],
  },
  {
    id: 'material',
    boostLabel: 'Material',
    fallbackParam: 'material',
    question: 'Preferred material?',
    options: [
      { label: 'TPE — softest feel', key: 'TPE' },
      { label: 'Silicone — most durable', key: 'Silicone' },
      { label: 'Silicone & TPE hybrid', key: 'Silicone & TPE' },
    ],
  },
  {
    id: 'weight',
    boostLabel: 'Weight',
    fallbackParam: 'weight',
    question: 'How much weight are you comfortable handling?',
    options: [
      { label: 'Very light (under 25kg)', key: 'Under 25kg' },
      { label: 'Light (under 30kg)', key: 'Under 30kg' },
      { label: '30kg – 35kg', key: '30kg - 35kg' },
      { label: '36kg – 40kg', key: '36kg - 40kg' },
      { label: '41kg – 45kg', key: '41kg - 45kg' },
      { label: 'Heavier (over 45kg)', key: 'Over 45kg' },
    ],
  },
];

/* ===================== DO NOT EDIT BELOW THIS LINE ======================= */

(function () {
  'use strict';

  var BOOST_ENDPOINT = 'https://services.mybcapps.com/bc-sf-filter/filter';
  var CACHE_TTL_MS = 30 * 60 * 1000;

  // Boost only applies the filter with array-style params:
  //   pf_t_doll_type[]=Asian   (comma-joined pf_t_doll_type=Asian is ignored)
  var USE_BOOST_API = true;

  function normalize(str) {
    return String(str || '').trim().toLowerCase();
  }

  function encodeValue(value) {
    return encodeURIComponent(String(value)).replace(/%20/g, '+');
  }

  // pf_t_doll_type -> doll_type
  function prettyParamFromOptionId(optionId) {
    return String(optionId || '').replace(/^pf_[a-z]+_/, '');
  }

  // Defined inline in sections/doll-finder-quiz.liquid (it also runs before
  // paint); without it, treat the page as unfiltered.
  function hasActiveFilters() {
    return typeof window.dollFinderHasFilters === 'function' && window.dollFinderHasFilters();
  }

  // Boost changes filters via history.pushState without a reload; announce
  // every URL change so the quiz can react. Patched once per page.
  function watchUrlChanges() {
    if (window.__dollFinderUrlWatch) return;
    window.__dollFinderUrlWatch = true;
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var ret = original.apply(this, arguments);
        window.dispatchEvent(new Event('dollfinder:urlchange'));
        return ret;
      };
    });
    window.addEventListener('popstate', function () {
      window.dispatchEvent(new Event('dollfinder:urlchange'));
    });
  }

  /* --- Data sources: both expose load() and query(selections) returning
     { total, countsFor(question) }, so quiz logic doesn't care which runs. */

  /* --- Primary: Boost Filter API ---------------------------------------- */

  function BoostSource(shopDomain, collectionId) {
    this.shop = shopDomain;
    this.collectionId = collectionId;
    this.optionIdByLabel = {}; // 'doll type' -> 'pf_t_doll_type'
    this.exactKeys = {}; // 'pf_t_weight' -> { 'under 30kg': 'Under 30kg' }
  }

  BoostSource.prototype.buildUrl = function (selections) {
    var self = this;
    var params = [
      'shop=' + encodeURIComponent(this.shop),
      'build_filter_tree=true',
      'limit=1',
      'product_available=true',
      'event_type=filter',
    ];

    if (this.collectionId) {
      params.push('collection_scope=' + encodeURIComponent(this.collectionId));
    }

    // Group values by Boost filter, so questions sharing one filter merge
    // into a single param.
    var grouped = {};
    Object.keys(selections).forEach(function (questionId) {
      var entry = selections[questionId];
      if (!entry) return;
      var optionId = self.optionIdByLabel[normalize(entry.boostLabel)];
      if (!optionId) return;
      // Prefer Boost's own spelling so a config casing mismatch can't
      // silently zero out results.
      var known = self.exactKeys[optionId] || {};
      var value = known[normalize(entry.key)] || entry.key;
      if (!grouped[optionId]) grouped[optionId] = [];
      if (grouped[optionId].indexOf(value) === -1) {
        grouped[optionId].push(value);
      }
    });

    Object.keys(grouped).forEach(function (optionId) {
      grouped[optionId].forEach(function (value) {
        params.push(optionId + '[]=' + encodeValue(value));
      });
    });

    return BOOST_ENDPOINT + '?' + params.join('&');
  };

  BoostSource.prototype.request = function (selections) {
    var self = this;
    return fetch(this.buildUrl(selections), { method: 'GET' })
      .then(function (res) {
        if (!res.ok) throw new Error('Boost API responded ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || typeof data.total_product === 'undefined') {
          throw new Error('Boost API returned an unexpected shape');
        }

        var options = (data.filter && data.filter.options) || [];
        var countsByOptionId = {};

        options.forEach(function (option) {
          if (option.label) {
            self.optionIdByLabel[normalize(option.label)] = option.filterOptionId;
          }
          var byKey = {};
          var exact = {};
          if (Array.isArray(option.values)) {
            option.values.forEach(function (value) {
              byKey[normalize(value.key)] = value.doc_count;
              exact[normalize(value.key)] = value.key;
            });
          }
          countsByOptionId[option.filterOptionId] = byKey;
          // Merge, don't replace — a filtered response only lists values
          // still in play; keep spellings learned from earlier calls.
          self.exactKeys[option.filterOptionId] = Object.assign(
            self.exactKeys[option.filterOptionId] || {},
            exact
          );
        });

        return {
          total: data.total_product,
          countsByOptionId: countsByOptionId,
          optionIdByLabel: self.optionIdByLabel,
        };
      });
  };

  BoostSource.prototype.load = function () {
    // Empty call both proves the API works and populates label -> optionId.
    return this.request({});
  };

  BoostSource.prototype.query = function (selections) {
    return this.request(selections);
  };

  BoostSource.prototype.countsFor = function (result, question) {
    var optionId = result.optionIdByLabel[normalize(question.boostLabel)];
    if (!optionId) return null;
    return result.countsByOptionId[optionId] || {};
  };

  BoostSource.prototype.paramFor = function (result, question) {
    var optionId = result.optionIdByLabel[normalize(question.boostLabel)];
    return optionId
      ? prettyParamFromOptionId(optionId)
      : question.fallbackParam;
  };

  /* --- Fallback: Shopify products.json ---------------------------------- */

  function LocalSource(collectionHandle) {
    this.handle = collectionHandle;
    this.products = null;
  }

  LocalSource.prototype.cacheKey = function () {
    return 'doll_finder_cache_' + this.handle;
  };

  LocalSource.prototype.readCache = function () {
    try {
      var raw = sessionStorage.getItem(this.cacheKey());
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.timestamp) return null;
      if (Date.now() - parsed.timestamp > CACHE_TTL_MS) return null;
      return parsed.products;
    } catch (e) {
      return null;
    }
  };

  LocalSource.prototype.writeCache = function (products) {
    try {
      sessionStorage.setItem(
        this.cacheKey(),
        JSON.stringify({ timestamp: Date.now(), products: products })
      );
    } catch (e) {
      /* storage unavailable — non-fatal */
    }
  };

  LocalSource.prototype.load = function () {
    var self = this;
    var cached = this.readCache();
    if (cached) {
      this.products = cached;
      return Promise.resolve(this.buildResult({}));
    }

    var results = [];

    function fetchPage(page) {
      var url =
        '/collections/' +
        encodeURIComponent(self.handle) +
        '/products.json?limit=250&page=' +
        page;

      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('products.json failed on page ' + page);
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (products.length === 0) return;

          products.forEach(function (p) {
            var tags = Array.isArray(p.tags)
              ? p.tags
              : String(p.tags || '')
                  .split(',')
                  .map(function (t) { return t.trim(); })
                  .filter(Boolean);
            results.push({ tags: tags });
          });

          if (products.length === 250) return fetchPage(page + 1);
        });
    }

    return fetchPage(1).then(function () {
      self.products = results;
      self.writeCache(results);
      return self.buildResult({});
    });
  };

  LocalSource.prototype.hasTag = function (product, value) {
    var target = normalize(value);
    return product.tags.some(function (t) { return normalize(t) === target; });
  };

  LocalSource.prototype.matching = function (selections) {
    var self = this;
    var values = Object.keys(selections)
      .map(function (k) { return selections[k] && selections[k].key; })
      .filter(Boolean);

    if (values.length === 0) return this.products;
    return this.products.filter(function (p) {
      return values.every(function (v) { return self.hasTag(p, v); });
    });
  };

  LocalSource.prototype.buildResult = function (selections) {
    var pool = this.matching(selections);
    return { total: pool.length, pool: pool, selections: selections };
  };

  LocalSource.prototype.query = function (selections) {
    return Promise.resolve(this.buildResult(selections));
  };

  LocalSource.prototype.countsFor = function (result, question) {
    var self = this;
    var counts = {};
    question.options.forEach(function (option) {
      var n = 0;
      for (var i = 0; i < result.pool.length; i++) {
        if (self.hasTag(result.pool[i], option.key)) n++;
      }
      counts[normalize(option.key)] = n;
    });
    return counts;
  };

  LocalSource.prototype.paramFor = function (result, question) {
    return question.fallbackParam;
  };

  /* --- Quiz --------------------------------------------------------------- */

  function DollFinderQuiz(root) {
    this.root = root;
    this.collectionHandle = root.getAttribute('data-collection-handle');
    this.collectionUrl = root.getAttribute('data-collection-url');
    this.collectionId = root.getAttribute('data-collection-id');
    this.shopDomain = root.getAttribute('data-shop-domain');
    this.showCounts = root.getAttribute('data-show-counts') !== 'false';
    this.startOpen = root.getAttribute('data-start-open') !== 'false';

    this.toggleBtn = root.querySelector('[data-doll-finder-toggle]');
    this.panel = root.querySelector('[data-doll-finder-panel]');
    this.stepLabel = root.querySelector('[data-doll-finder-step-label]');
    this.progressFill = root.querySelector('[data-doll-finder-progress]');
    this.loadingEl = root.querySelector('[data-doll-finder-loading]');
    this.questionArea = root.querySelector('[data-doll-finder-question-area]');
    this.noticeEl = root.querySelector('[data-doll-finder-notice]');
    this.countRow = root.querySelector('[data-doll-finder-count-row]');
    this.countNumber = root.querySelector('[data-doll-finder-count]');
    this.backBtn = root.querySelector('[data-doll-finder-back]');
    this.restartBtn = root.querySelector('[data-doll-finder-restart]');
    this.resultsBtn = root.querySelector('[data-doll-finder-results]');

    this.source = null;
    this.result = null;
    this.selections = {}; // questionId -> { key, boostLabel }
    // { id, stepIndex } stack — "previous" isn't "one back" since skipped
    // (non-narrowing) questions don't get a step.
    this.history = [];
    this.stepIndex = 0;
    this.displayedCount = null;
    this.busy = false;
    this.started = false;

    this.bindEvents();

    // Filters in the URL -> collapsed; none -> the "Open by default" setting.
    this.hasFilters = hasActiveFilters();
    this.setOpen(!this.hasFilters && this.startOpen);
  }

  DollFinderQuiz.prototype.setOpen = function (open) {
    this.panel.hidden = !open;
    this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !this.started) this.start();
  };

  DollFinderQuiz.prototype.bindEvents = function () {
    var self = this;

    this.toggleBtn.addEventListener('click', function () {
      self.setOpen(self.panel.hidden);
    });

    // Only react when the page flips between filtered and unfiltered, so a
    // sort/page change or an extra filter never closes a quiz the shopper opened.
    watchUrlChanges();
    window.addEventListener('dollfinder:urlchange', function () {
      var now = hasActiveFilters();
      if (now === self.hasFilters) return;
      self.hasFilters = now;
      self.setOpen(!now && self.startOpen);
    });

    this.backBtn.addEventListener('click', function () { self.goBack(); });
    this.restartBtn.addEventListener('click', function () { self.restart(); });
    this.resultsBtn.addEventListener('click', function () {
        var label = self.resultsBtn.getAttribute('data-ga-quiz');

        if (typeof gtag === 'function') {
            gtag('event', 'doll_finder_quiz', {
            event_category: 'Doll Finder Quiz',
            event_label: label,
            });
        }

        self.goToResults();
    });
  };

  DollFinderQuiz.prototype.start = function () {
    var self = this;
    this.started = true;
    this.loadingEl.hidden = false;
    this.questionArea.innerHTML = '';

    var boost =
      USE_BOOST_API && this.shopDomain
        ? new BoostSource(this.shopDomain, this.collectionId)
        : null;

    var attempt = boost
      ? boost.load().then(function (result) {
          self.source = boost;
          return result;
        })
      : Promise.reject(new Error('No shop domain available'));

    attempt
      .catch(function (err) {
        if (USE_BOOST_API && window.console) {
          console.warn('Doll Finder: Boost API unavailable, using fallback.', err);
        }
        var local = new LocalSource(self.collectionHandle);
        return local.load().then(function (result) {
          self.source = local;
          return result;
        });
      })
      .then(function (result) {
        self.result = result;
        self.loadingEl.hidden = true;
        self.renderStep();
      })
      .catch(function (err) {
        self.loadingEl.hidden = true;
        self.questionArea.innerHTML =
          '<p class="doll-finder__notice">The quiz is unavailable right now. Use the filters to browse the collection.</p>';
        if (window.console) console.error(err);
      });
  };

  DollFinderQuiz.prototype.restart = function () {
    var self = this;
    this.selections = {};
    this.history = [];
    this.stepIndex = 0;
    this.noticeEl.hidden = true;
    this.resultsBtn.hidden = true;
    this.refresh();
  };

  DollFinderQuiz.prototype.goBack = function () {
    if (this.history.length === 0 || this.busy) return;
    var last = this.history.pop();
    delete this.selections[last.id];
    this.stepIndex = last.stepIndex;
    this.noticeEl.hidden = true;
    this.refresh();
  };

  DollFinderQuiz.prototype.refresh = function () {
    var self = this;
    this.busy = true;
    this.setOptionsDisabled(true);

    this.source
      .query(this.selections)
      .then(function (result) {
        self.result = result;
        self.busy = false;
        self.renderStep();
      })
      .catch(function (err) {
        self.busy = false;
        self.setOptionsDisabled(false);
        self.noticeEl.hidden = false;
        self.noticeEl.textContent =
          'Could not update the results just now. Please try that again.';
        if (window.console) console.error(err);
      });
  };

  DollFinderQuiz.prototype.setOptionsDisabled = function (disabled) {
    this.questionArea
      .querySelectorAll('.doll-finder__option')
      .forEach(function (btn) {
        btn.disabled = disabled;
        btn.style.opacity = disabled ? '0.55' : '';
      });
  };

  // Options with zero results are dropped; a question with < 2 live options
  // can't narrow anything, so it's skipped entirely (see renderStep).
  DollFinderQuiz.prototype.liveOptionsFor = function (question) {
    var counts = this.source.countsFor(this.result, question);
    if (!counts) return [];

    var alreadyChosen = {};
    var self = this;
    Object.keys(this.selections).forEach(function (qid) {
      var entry = self.selections[qid];
      if (entry && qid !== question.id) alreadyChosen[normalize(entry.key)] = true;
    });

    return question.options
      .map(function (option) {
        return { option: option, count: counts[normalize(option.key)] || 0 };
      })
      .filter(function (entry) {
        return entry.count > 0 && !alreadyChosen[normalize(entry.option.key)];
      });
  };

  DollFinderQuiz.prototype.renderStep = function () {
    var total = DOLL_FINDER_QUESTIONS.length;

    if (this.stepIndex >= total) {
      this.renderComplete();
      return;
    }

    var question = DOLL_FINDER_QUESTIONS[this.stepIndex];
    var liveOptions = this.liveOptionsFor(question);

    if (liveOptions.length < 2) {
      this.stepIndex += 1;
      this.renderStep();
      return;
    }

    var self = this;
    this.stepLabel.textContent = 'Step ' + (this.stepIndex + 1) + ' of ' + total;
    this.progressFill.style.width =
      Math.round(((this.stepIndex + 1) / total) * 100) + '%';
    this.backBtn.disabled = this.history.length === 0;

    var html = '<p class="doll-finder__question-text">' + question.question + '</p>';
    html += '<div class="doll-finder__options">';

    liveOptions.forEach(function (entry) {
      html +=
        '<button type="button" class="doll-finder__option" data-option-key="' +
        encodeURIComponent(entry.option.key) +
        '">' +
        entry.option.label +
        (self.showCounts
          ? '<span class="doll-finder__option-count">' + entry.count + '</span>'
          : '') +
        '</button>';
    });

    html += '</div>';
    this.questionArea.innerHTML = html;

    this.questionArea.querySelectorAll('[data-option-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.choose(question, decodeURIComponent(btn.getAttribute('data-option-key')));
      });
    });

    var skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'doll-finder__skip';
    skipBtn.textContent = 'Not sure — skip this question';
    skipBtn.addEventListener('click', function () { self.choose(question, null); });
    this.questionArea.appendChild(skipBtn);

    this.updateCountDisplay();
  };

  DollFinderQuiz.prototype.choose = function (question, key) {
    if (this.busy) return;

    if (key === null) {
      delete this.selections[question.id];
    } else {
      this.selections[question.id] = { key: key, boostLabel: question.boostLabel };
    }

    this.history.push({ id: question.id, stepIndex: this.stepIndex });
    this.noticeEl.hidden = true;
    this.stepIndex += 1;
    this.refresh();
  };

  DollFinderQuiz.prototype.animateCountTo = function (target) {
    var el = this.countNumber;
    var start = this.displayedCount;
    this.displayedCount = target;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (start === null || reduceMotion || start === target) {
      el.textContent = target;
      return;
    }

    var duration = 420;
    var startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(start + (target - start) * eased);
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  };

  DollFinderQuiz.prototype.updateCountDisplay = function () {
    var total = this.result.total;
    var hasAnswered = Object.keys(this.selections).length > 0;

    this.countRow.hidden = false;
    this.animateCountTo(total);
    this.resultsBtn.hidden = !hasAnswered || total === 0;
    this.resultsBtn.textContent = 'Show my ' + total + ' matches →';
  };

  DollFinderQuiz.prototype.renderComplete = function () {
    var count = this.result.total;
    this.stepLabel.textContent = 'All done';
    this.progressFill.style.width = '100%';

    var message;
    if (count === 0) {
      message = 'No exact matches — try loosening one of your answers.';
    } else if (count === 1) {
      message = "🎉 Woohoo! We've narrowed it down to 1 doll!";
    } else {
      message = "🎉 Woohoo! We've narrowed it down to " + count + " dolls!";
    }
    this.questionArea.innerHTML =
      '<p class="doll-finder__question-text">' + message + '</p>';

    this.countRow.hidden = false;
    this.animateCountTo(count);
    this.resultsBtn.hidden = count === 0;
    this.resultsBtn.textContent = 'Show my ' + count + ' matches →';
    this.backBtn.disabled = this.history.length === 0;
  };

  // Sends to the collection filtered like the sidebar would:
  // ?doll_type=Hentai,Petite&breast_size=Small+Breasts
  DollFinderQuiz.prototype.goToResults = function () {
    var self = this;
    var grouped = {};

    DOLL_FINDER_QUESTIONS.forEach(function (question) {
      var entry = self.selections[question.id];
      if (!entry) return;
      var param = self.source.paramFor(self.result, question);
      if (!param) return;
      if (!grouped[param]) grouped[param] = [];
      if (grouped[param].indexOf(entry.key) === -1) grouped[param].push(entry.key);
    });

    var parts = Object.keys(grouped).map(function (param) {
      return param + '=' + grouped[param].map(encodeValue).join(',');
    });

    window.location.href = parts.length
      ? this.collectionUrl + '?' + parts.join('&')
      : this.collectionUrl;
  };

  function initAll() {
    document.querySelectorAll('[data-doll-finder]').forEach(function (root) {
      new DollFinderQuiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();